import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const links = [{
    href: '/find-hostel',
    label: 'Find Hostel'
  }, {
    href: '/roommate-match',
    label: 'Roommate Match'
  }, {
    href: '/marketplace',
    label: 'Marketplace'
  }, {
    href: '/ambassadors',
    label: 'Ambassadors'
  }];
  return <nav className={`absolute top-0 w-full z-40 px-6 py-6 ${!isLanding ? 'bg-white border-b border-slate-100' : ''}`} data-id="element-239">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-240">
        <Link to="/" className="flex items-center gap-2 z-50" data-id="element-241">
          <img src="https://cdn.magicpatterns.com/uploads/37CjFFhCaYFTTZ1oinSNtZ/Cam_main_ver_logo.png" alt="CampusAparte" className="h-10 w-auto" data-id="element-242" />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 text-sm font-medium text-slate-600 items-center" data-id="element-243">
          {links.map(link => <Link key={link.href} to={link.href} className={`transition-colors ${location.pathname === link.href ? 'text-brand-primary font-semibold' : 'hover:text-brand-primary'}`} data-id="element-244">
              {link.label}
            </Link>)}
          <Link to="/login" data-id="element-245">
            <Button variant="ghost" size="sm" className="font-semibold text-brand-dark hover:text-brand-primary" data-id="element-246">
              Login
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 text-brand-dark" onClick={() => setIsOpen(!isOpen)} data-id="element-247">
          {isOpen ? <X data-id="element-248" /> : <Menu data-id="element-249" />}
        </button>

        {/* Mobile Menu Overlay */}
        <AnimatePresence data-id="element-250">
          {isOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute inset-0 top-0 left-0 w-full h-screen bg-white flex flex-col items-center justify-center gap-8 md:hidden z-40" data-id="element-251">
              {links.map(link => <Link key={link.href} to={link.href} className="text-xl font-medium text-brand-dark hover:text-brand-primary" onClick={() => setIsOpen(false)} data-id="element-252">
                  {link.label}
                </Link>)}
              <Link to="/login" onClick={() => setIsOpen(false)} data-id="element-253">
                <Button size="lg" className="w-40" data-id="element-254">
                  Login
                </Button>
              </Link>
            </motion.div>}
        </AnimatePresence>
      </div>
    </nav>;
}